import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavbarService {
  public focarNumeroMesaInput$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public numeroComandaDigitado$: BehaviorSubject<number> = new BehaviorSubject(null);
  public idSessao: string = '';

  constructor() {
    this.idSessao = this.generateUniqueId();
  }
  
  private generateUniqueId(): string {
    return Math.random().toString(36).substr(2, 9);
  }
}
